export async function getHistory() {
    const response = await fetch(`https://cfc-api.juliansteiner.me/cowfeedcalculator/calculations`, {
        method: "GET",
        headers: { "Content-Type": "application/json" },
    });
    
    return await response.json();
}

export async function saveCalculation(feedTypes) {
    const response = await fetch(`https://cfc-api.juliansteiner.me/cowfeedcalculator/calculation/save`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ feedTypes: feedTypes }),
    });

    return await response.json();
}